<template>
  <a-popover
    v-model="visible"
    trigger="click"
    placement="top"
    overlay-class-name="dd-tip-pop"
  >
    <div
      slot="content"
      class="dd-tip-pop-content"
      @click="hide"
    >
      <div class="dd-tip-item">
        <h4>{{ $t('message["1717"]') }}</h4>
        <p>13613835754</p>
      </div>
      <div class="dd-tip-item">
        <h4>{{ $t('message["1505"]') }}</h4>
        <p>gengxueya@gongchang.com</p>
      </div>
      <div class="dd-tip-item">
        <h4>{{ $t('message["238"]') }}</h4>
        <p>
          <img
            src="../../../assets/images/contactding.jpg"
            height="104"
            width="104"
          >
        </p>
      </div>
    </div>
    <a-button
      v-if="type==='upgrade'"
      type="primary"
      class="s-i-btn s-i-advanced-btn"
    >
      {{ $t('message["599"]') }}
    </a-button>
    <a-button
      v-else-if="type === 'xf'"
      class="renewal"
      type="primary"
      v-text="txt"
    />
    <span
      v-else-if="type === 'expand'"
      class="expation_btn"
    >扩容</span>
  </a-popover>
</template>
<style lang="scss" scoped>
.dd-tip-pop-content {
  .dd-tip-item {
    line-height: 20px;
    margin-bottom: 8px;
    font-size: 12px;
    h4{
      color: #666;
      margin-bottom: 4px;
    }
    p{
      font-weight: bold;
    }
  }
}
</style>
<script>
export default {
  props: {
    type: {
      type: String,
      default: ''
    },
    txt: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      visible: false
    }
  },
  methods: {
    hide () {
      this.visible = false
    }
  }
}
</script>
